import {
    CalendarClock,
    CalendarDays,
    FolderKanban,
    Users,
} from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { USE_STATIC_SITE_CONTENT } from '../config/staticSiteMode';
import { STATIC_HOME_STATS } from '../data/staticSite/content';

const DEFAULT_STATS = {
    members: 128,
    events: 24,
    projects: 18,
    meetings: 52,
};

/**
 * Ana sayfa istatistik şeridi — CMS `Statistics/GetHome` ile doldurulur;
 * hata durumunda `DEFAULT_STATS` kullanılır.
 */
export function Stats() {
    const { t, i18n } = useTranslation();
    const numLocale = i18n.language?.toLowerCase().startsWith('en')
        ? 'en-US'
        : 'tr-TR';

    const [stats, setStats] = useState(
        USE_STATIC_SITE_CONTENT ? STATIC_HOME_STATS : DEFAULT_STATS,
    );
    const [loading, setLoading] = useState(!USE_STATIC_SITE_CONTENT);

    useEffect(() => {
        if (USE_STATIC_SITE_CONTENT) {
            setStats(STATIC_HOME_STATS);
            setLoading(false);
            return undefined;
        }

        let cancelled = false;

        /*
        (async () => {
            try {
                const data = await fetchCmsHomeStatistics();
                if (!cancelled) {
                    setStats(data);
                }
            } catch {
                if (!cancelled) {
                    setStats(DEFAULT_STATS);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        })();
        */

        return () => {
            cancelled = true;
        };
    }, []);

    const items = [
        {
            key: 'members',
            value: stats.members,
            label: t('home.stats.members'),
            Icon: Users,
        },
        {
            key: 'events',
            value: stats.events,
            label: t('home.stats.events'),
            Icon: CalendarDays,
        },
        {
            key: 'projects',
            value: stats.projects,
            label: t('home.stats.projects'),
            Icon: FolderKanban,
        },
        {
            key: 'meetings',
            value: stats.meetings,
            label: t('home.stats.meetings'),
            Icon: CalendarClock,
        },
    ];

    return (
        <section
            className="stats-section"
            aria-labelledby="stats-baslik"
            aria-busy={loading}
        >
            <div className="container">
                <h2
                    id="stats-baslik"
                    className="haberler-section-title stats-section-heading text-center mb-0"
                >
                    {t('home.stats.title')}
                </h2>
                <ul className="stats-strip list-unstyled mb-0">
                    {items.map(({ key, value, label, Icon }) => (
                        <li key={key} className="stats-stat text-center">
                            <span className="stats-stat-icon-wrap d-inline-flex align-items-center justify-content-center">
                                <Icon
                                    size={26}
                                    strokeWidth={1.75}
                                    className="stats-stat-icon"
                                    aria-hidden
                                />
                            </span>
                            <p
                                className="stats-stat-value mb-2 tabular-nums"
                                aria-label={`${value} ${label}`}
                            >
                                {value.toLocaleString(numLocale)}
                            </p>
                            <p className="stats-stat-label mb-0">{label}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
